<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import {Navigation, Thumbs, FreeMode, Mousewheel, Keyboard} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/free-mode";
import {ref} from "vue";

const props = defineProps({
  images: {
    type: Array,
    required: true,
  },
});

const thumbsSwiper = ref(null);
const setThumbsSwiper = (swiper) => {
  thumbsSwiper.value = swiper;
};
</script>


<template>
  <div class="relative">
    <!-- Main Slider -->
    <Swiper
        :modules="[Navigation, Thumbs, Keyboard, Mousewheel]"
        :slides-per-view="1"
        :space-between="10"
        :loop="false"
        :navigation="true"
        :speed="800"
        :thumbs="{ swiper: thumbsSwiper }"
        :keyboard="{ enabled: true, onlyInViewport: false }"
        :mousewheel="{ forceToAxis: true}"
        class="main-swiper h-[60vh] mb-4"
    >
      <SwiperSlide v-for="(image, index) in images" :key="index">
        <div class="flex justify-center items-center h-full">
          <img
              :src="image.original"
              class="popup-image h-[65vh] object-cover mx-10"
          />
        </div>
      </SwiperSlide>
    </Swiper>

    <!-- Thumbnails Slider -->
    <Swiper
        @swiper="setThumbsSwiper"
        :modules="[FreeMode, Thumbs, Mousewheel]"
        :slides-per-view="4"
        :space-between="20"
        :free-mode="true"
        watch-slides-progress
        :mousewheel="{ forceToAxis: true}"
        class="thumbs-swiper h-[15vh] md:max-w-[60%] lg:max-w-[65%] mx-auto"
    >
      <SwiperSlide v-for="(image, index) in images" :key="index">
        <img
            :src="image.original"
            class="object-cover h-full w-full cursor-pointer"
        />
      </SwiperSlide>
    </Swiper>
  </div>
</template>


<style scoped>



/* For main slider's active slide */
:deep(.main-swiper .swiper-slide):not(.swiper-slide-active) {
  transform: scale(0.9);
}

/* For thumbs slider's active thumbnail */
:deep(.thumbs-swiper .swiper-slide-thumb-active img) {
  transform: scale(1.05);
  opacity: 1 !important;
  transition: all 0.3s ease;
}

:deep(.thumbs-swiper .swiper-slide:not(.swiper-slide-thumb-active) img) {
  opacity: 0.7;
}


:deep(.swiper-button-prev),
:deep(.swiper-button-next) {
  width: 60px;
  height: 60px;
}

:deep(.swiper-button-prev:after),
:deep(.swiper-button-next:after) {
  font-size: 30px;
  color: #691736;
}

@media (min-width: 1024px) {
  :deep(.swiper-button-prev) {
    left: 5%;
  }

  :deep(.swiper-button-next) {
    right: 5%;
  }
}


</style>

